import "date-fns";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";

import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {
  IconButton,
} from "@material-ui/core";
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");
import { message } from "constants/message";

const useStyles = makeStyles(() => ({
  dateTimePicker: {
    width: "160px",
  },
  dateTimePickerComplex: {
    width: "256px",
  },
}));

export default function MaterialUIPickers({
  dateTime,
  handleDateChange,
  step,
  mediaFlag = false
}) {
  const classes = useStyles();
  const messages = message();
  const minDate = mediaFlag ? dayjs().subtract(18, "month")
                            : dayjs().subtract(3, "month");
  const maxDate = dayjs();
  const minutesStep = step === "minutes" ? 5 : 60;

  const desabledMinDatetime = () => {
    let minDateTime = null;
    if (step === "minutes") {
      minDateTime = dayjs(minDate).format("YYYY-MM-DD 00:05:00");
    } else {
      minDateTime = dayjs(minDate).format("YYYY-MM-DD 01:00:00");
    }
    return dayjs(minDateTime).isSame(dayjs(dateTime), "dateTime");
  }

  const desabledMaxDatetime = () => {
    let maxDateTime = null;
    if (step === "minutes") {
      maxDateTime = dayjs(maxDate).format("YYYY-MM-DD 23:55:00");
    } else {
      maxDateTime = dayjs(maxDate).format("YYYY-MM-DD 23:00:00");
    }
    return dayjs(maxDateTime).isSame(dayjs(dateTime), "dateTime");
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container direction="row" alignItems="center" className={classes.dateTimePickerComplex}>
        <Grid item>
          <IconButton
            color="primary"
            component="span"
            onClick={() => {
              if (step === "minutes") {
                handleDateChange(
                  dayjs(dateTime).add(-5, "m").format("YYYY-MM-DD HH:mm:ss")
                );
              } else {
                handleDateChange(
                  dayjs(dateTime).add(-1, "hour").format("YYYY-MM-DD HH:mm:ss")
                );
              }
            }}
            disabled={desabledMinDatetime()}
          >
            <ArrowLeftIcon />
          </IconButton>
        </Grid>
        <Grid item>
          <DateTimePicker
            value={dateTime}
            minDate={minDate}
            minDateMessage={
              (messages.validation.minDate).replace(
                "$1",
                minDate.format("YYYY-MM-DD")
              )
            }
            maxDate={maxDate}
            maxDateMessage={
              (messages.validation.maxDate).replace(
                "$1",
                maxDate.format("YYYY-MM-DD")
              )
            }
            onChange={(dateTime) =>
              handleDateChange(dayjs(dateTime).format("YYYY-MM-DD HH:mm:ss"))
            }
            minutesStep={minutesStep}
            format="yyyy/MM/dd HH:mm:ss"
            className={classes.dateTimePicker}
          />
        </Grid>
        <Grid item>
          <IconButton
            color="primary"
            component="span"
            onClick={() => {
              if (step === "minutes") {
                handleDateChange(
                  dayjs(dateTime).add(5, "m").format("YYYY-MM-DD HH:mm:ss")
                );
              } else {
                handleDateChange(
                  dayjs(dateTime).add(1, "hour").format("YYYY-MM-DD HH:mm:ss")
                );
              }
            }}
            disabled={desabledMaxDatetime()}
          >
            <ArrowRightIcon />
          </IconButton>
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
